import Stripe from 'stripe';
export const getStripeSecretKey = () => {
    const key = process.env.STRIPE_SECRET_KEY?.trim();
    if (!key) {
        throw new Error('STRIPE_SECRET_KEY environment variable is required');
    }
    return key;
};
export const getStripePublishableKey = () => {
    // This function is for client-side use, but in shared package we'll return empty string
    // The actual implementation will be in the client-side code
    return '';
};
// Only initialize Stripe on server-side (Node.js environment)
export const stripe = typeof window === 'undefined'
    ? new Stripe(getStripeSecretKey(), {
        apiVersion: '2025-10-29.clover',
        typescript: true,
    })
    : null; // Client-side will be null
